// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KP6xZ","inner":"Footer_inner__gMvFp","nextIcon":"Footer_nextIcon__2N-ht","innerLeft":"Footer_innerLeft__2Ou1z"};